import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import { useAxios } from "auth-sdk";
import type { AxiosResponse } from "axios";
import { useCustomerAppConfig } from "undercarriage";

type FieldOptionsResponse<T = any> = {
  [key: string]: T;
};

export const useCompanyFieldOptions = (): UseQueryResult<FieldOptionsResponse> => {
  const client = useAxios();
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();
  const requestPath = `/${customerDomain}/verify-business/get-field-options`;

  return useQuery({
    queryKey: ["getVerifyBusinessFieldOptions"],
    queryFn: () => client.get<FieldOptionsResponse>(requestPath),
    select: ({ data }: AxiosResponse<FieldOptionsResponse>) => data,
  });
};
